export class UserRoleDTO
{
    public id! : number; 
    public name! : string; //Super Admin=10, Customer Admin=20, Customer User=30, Client User=40, Vendor Admin=50, Vendor User=60
}